import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SyncDisabledSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SyncDisabledSVG;
